import React, { Component } from "react";
import { translate } from "react-i18next";
import swal from 'sweetalert';
import isEmail from "validator/lib/isEmail";
import AutocompleteForm from "../../components/AutocompleteForm";
import InputMaskForm from "../../components/InputMaskForm";
import InputForm from "../../components/InputForm";
import LabelForm from "../../components/LabelForm";
import SelectForm from "../../components/SelectForm";
import { lookups, lookupsNotRender, nationalCenterActive } from "../../libs/services";
import { calcularEdad, isValidaDate, validString } from "../../libs/functions";
import moment from "moment";

class DonorData extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.availableEdit = this.availableEdit.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);
        this.setJobProfile = this.setJobProfile.bind(this);
        this.clearData = this.clearData.bind(this);

        this.state = {
            recurrent:"",
            load_national:false,
            index_national:-1,
            nationalSelected:[],
            recurrent_center_id:"",
            national_centers:[],
            document_type:"DOCUMENT_INE",
            document_number:"",
            documents:[],
            genders:[{value:"HOMBRE", text:'HOMBRE'},{value:"MUJER", text:'MUJER'}],
            civil_status_array:[],
            civil_status:"",
            birthday:"",
            age:"",
            names:"",
            lastname1:"",
            lastname2:"",
            email:"",
            error_email:"",
            scholarship:"",
            scholarships:[],
            index_job:-1,
            job_profile:"",
            jobProfiles:[],
            load_job:false,
            show_recurrent:false,
            mother_data:false,
            id:"",
            person_id:"",
            donor_id:"",
            idee:"",
            error_date:"",
            donor_number:"",
        }
    }

    async componentDidMount(){
        this.props.onRef(this);
        var options = [];
        var response = await nationalCenterActive();
        if(response){
            response.forEach((res)=>{
                res.values = res.national_center.name;
            });

            this.setState({
                national_centers: response
            });
        }

        response = await lookupsNotRender('document_type');
        if(response){
            options = [];
            options = response.map((res)=>{
                var obj = {
                    value:res.key,
                    text:res.name
                };
                return obj;
            });

            this.setState({ documents: options });
        }

        response = await lookups('CIVIL_STATUS', 'false');
        if(response){
            options = [];
            var options = response.map((res)=>{
                var obj = {
                    value:res.key,
                    text:res.name
                };
                return obj;
            });

            this.setState({civil_status_array: options});
        }

        response = await lookups('SCHOOLING', 'false');
        if(response){
            options = [];
            var options = response.map((res)=>{
                var obj = {
                    value:res.key,
                    text:res.name
                };
                return obj;
            });
            this.setState({ scholarships: options});
        }

        response = await lookups('profession', 'false');
        if(response){
            response.forEach((res)=>{
                res.values = res.name;
            });

            await this.setState({ jobProfiles: response });

        }
    }

    handleChange(e){
        if(e.target.name === 'names' || e.target.name === 'lastname1' || e.target.name === 'lastname2'){
			if(e.target.value === ""){
                this.setState({[e.target.name]: e.target.value});
            }
            if(validString(e.target.value, 'donor')){
				this.setState({[e.target.name]: e.target.value});
			}
		}else{
            this.setState({[e.target.name]: e.target.value});
        }

        if(e.target.name === 'birthday'){
            var control = document.getElementById(e.target.id);
            
            if(isValidaDate(e.target.value)){
                control.classList.remove('error');
                this.setState({error_date:''});
            }else{
                control.classList.add('error');
                this.setState({error_date: e.target.value === '' ? '' : 'Fecha no valida'});
            }

            var edad = calcularEdad(e.target.value);
            if(edad > 0){
                this.setState({age:edad});
            }else{
                this.setState({age:''});
            }
        }

        if(e.target.name === 'email'){
			if(!isEmail(e.target.value)){
				this.setState({error_email: e.target.value !== "" ? 'Formato no valido' : ""});
			}else{
				this.setState({error_email: ''});
			}
        }
    }

    handleCheck(e){
        this.setState({[e.target.name]: e.target.checked});
    }

    availableEdit(e){
        this.props.onChange({
            target:{
                name:'blockFields',
                value:!e.target.checked
            }
        });		
	}

    onAutocompleteChange(values, name){
        if(values.length > 0){
            if(name === 'recurrent_center_id'){
                this.setState({
                    recurrent_center_id:values[0].national_center.id
                });
            }

            if(name === 'job_profile'){
                var index = this.state.jobProfiles.findIndex(item => item.key === values[0].key);
                this.setState({
                    job_profile:values[0].key,
                    index_job:index
                });
            }
            
        }else if(this.state.nationalSelected.length > 0){
        	this.setState({
                index_national:-1,
        		nationalSelected:[]
        	});
        }
	}

    getData(obj){
        obj = { ...obj, offering_cells: {...obj.offering_cells, donor_age:this.state.age}};
        obj = {...obj, donor:{
            ...obj.donor,
            person:{
                ...obj.donor.person,
                person_type:'DONOR',
                names:this.state.names,
                lastname1:this.state.lastname1,
                civil_status:this.state.civil_status,
                birthday:this.state.birthday !== "" ? this.state.birthday.length === 10 ? 
                    moment(this.state.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD') : "invalid date" : "",
                sex:this.state.sex,
                scholarship:this.state.scholarship,
                job_profile: this.state.job_profile,
                email: this.state.email,
                lastname2:this.state.lastname2,
                idee: this.state.idee,
                documents:[{
                    document_type:this.state.document_type,
                    document_number: this.state.document_number
                }]
            }
        }};

        return obj;
    }

    async setJobProfile(item){
        var index = this.state.jobProfiles.findIndex(obj => obj.key === item.person.job_profile);
        if(index !== -1){
            var item = [this.state.jobProfiles[index]];
            await this.onAutocompleteChange(item, 'job_profile');
        }  
    }

    async setData(item){
        var edad = calcularEdad(moment(item.person.birthday).format('DD/MM/YYYY'));

        await this.setState({
            donor_id:item.donor.id,
            person_id: item.donor.person_id,
            donor_number: item.donor.donor_number,
            idee:item.person.idee !== null ? item.person.idee : "",
            job_profile:item.person.job_profile !== null ? item.person.job_profile : '',
            lastname1:item.person.lastname1,
            lastname2:item.person.lastname2,
            names:item.person.names,
            scholarship:item.person.scholarship !== null ? item.person.scholarship : "",
            sex:item.person.sex,
            birthday:item.person.birthday !== null && item.person.birthday !== "" ? moment(item.person.birthday).format('DD/MM/YYYY') : "",
            age:edad,
            document_type:item.documents.length > 0 ? item.documents[0].document_type : "",
            document_number:item.documents.length > 0 ? item.documents[0].document_number : "",
            civil_status: item.person.civil_status !== null ? item.person.civil_status : '',
            email:item.person.email !== null ? item.person.email : '',
        });

        if(item.person.job_profile !== null){
            await this.setJobProfile(item);
        }
    }

    clearData(){
        this.setState({
            donor_id:"",
            person_id: "",
            donor_number: "",
            idee:"",
            job_profile:"",
            lastname1:"",
            lastname2:"",
            names:"",
            scholarship:"",
            sex:"",
            birthday:"",
            age:"",
            document_type:"",
            document_number:"",
            civil_status: "",
            email:"",
            idee:"",
            job_profile:"",
            index_job:-1
        })
    }

    render(){
        const {t} = this.props;

        return(
            <fieldset>
                <legend>Datos del Donador</legend>

                <div className="col-xs-12 form-group no-padding">
                    {this.props.checkEditData &&
                        <>
                            <input
                                className="form-check-input" 
                                type="checkbox" 
                                name="blockFields" 
                                onKeyPress={(e) => this.props.validate(e)}
                                value={ this.props.blockFields} 
                                onChange={(e)=>this.availableEdit(e)} 
                                style={{marginRight:'5px'}}
                            />
                            <LabelForm text="Editar Datos" />
                        </>
					}
                </div>
                {this.state.show_recurrent ?
                    <div className="col-xs-12 no-padding">
                        <div className="col-xs-12 col-sm-4">
                            <div className="col-xs-12 no-padding">
                                <LabelForm text="Ha usted donado sangre en los ultimos 2 años" />
                            </div>
                            <div className="col-xs-12 col-sm-6 no-padding">
                                <SelectForm 
                                    id="recurrent"
                                    value={this.state.recurrent}
                                    options={[{value:true, text:'Si'}, {value:false, text:'No'}]}
                                    handleChange={this.handleChange}
                                    disabled={this.props.blockFields}
                                />
                            </div>                        
                        </div>
                        {this.state.recurrent &&
                            <div className="col-xs-12 col-sm-4">
                                <LabelForm text="Banco de Sangre" />
                                <AutocompleteForm 
                                    disabled={this.props.blockFields}
                                    id="recurrent_center_id"
                                    validate={this.props.validate}
                                    options={this.state.national_centers}
                                    loading={this.state.load_national}
                                    handleChange={this.onAutocompleteChange}
                                    reference="_handleNationalCenter"
                                    onRef={ref => this.autocomplete_national = ref}
                                />
                            </div>
                        }
                    </div>
                : 
                    <div className="col-xs-12 form-group">
                        <input
                            className="form-check-input" 
                            type="checkbox" 
                            name="mother_data" 
                            onKeyPress={(e) => this.props.validate(e)}
                            value={ this.state.mother_data} 
                            onChange={(e)=>this.handleCheck(e)} 
                            style={{marginRight:'5px'}}
                        />
                        <LabelForm text="Datos de la Madre" />                    
                    </div>
                }
                <div className="col-xs-12 no-padding">
                    {this.props.fields.map((field, i)=>
                        field.section_key === 'DONOR' ?
                            field.print ?
                                field.key === 'DOCUMENT_NUMBER' ?
                                    <div key={i}>
                                        <div className="col-xs-12 col-sm-2" >
                                            <LabelForm text={t('content.offers.form.document_type')} />
                                            <SelectForm 
                                                id="document_type"
                                                options={this.state.documents}
                                                value={this.state.document_type}
                                                validate={this.props.validate}
                                                disabled={this.props.blockFields}
                                                handleChange={this.handleChange}
                                                required={field.required}
                                            />

                                        </div>
                                        <div className="col-xs-12 col-sm-2">
                                            <LabelForm text={t('content.offers.form.number')} />
                                            <InputForm 
                                                id="document_number"
                                                value={this.state.document_number}
                                                handleChange={this.handleChange}
                                                disabled={this.props.blockFields}
                                                required={field.required}
                                                validate={this.props.validate}
                                            />
                                        </div>
                                    </div>
                                : field.key === 'SEX' ?
                                    <div className="col-xs-12 col-sm-2" key={i}>
                                        <LabelForm text={t('content.offers.form.gender')} />
                                        <SelectForm 
                                            id="sex"
                                            value={this.state.sex}
                                            options={this.state.genders}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                        />
                                    </div>
                                : field.key === 'CIVIL_STATUS' ?
                                    <div className=" col-xs-12 col-sm-2"  key={i}>
                                        <LabelForm text={t('content.offers.form.civil_status')} />
                                        <SelectForm 
                                            id="civil_status"
                                            options={this.state.civil_status_array}
                                            value={this.state.civil_status}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                        />
                                    </div>
                                : field.key === 'BIRTHDAY' ?
                                    <div className=" col-xs-12 col-sm-4" style={{paddingLeft: 0}} key={i}>
                                        <div className="form-group col-xs-12 col-sm-8" style={{marginBottom: 0}}>
                                            <LabelForm text={t('content.offers.form.birthday')} />
                                            {this.state.error_date !== "" &&
                                                <LabelForm text={this.state.error_date} styles={{marginLeft:8, fontSize:11, color:'red'}} />
                                            }
                                            <InputMaskForm 
                                                id="birthday"
                                                value={this.state.birthday}
                                                handleChange={this.handleChange}
                                                validate={this.props.validate}
                                                disabled={this.props.blockFields}
                                                required={field.required}
                                            />
                                        </div>
                                        <div className="form-group col-xs-12 col-sm-4" style={{paddingRight: 0,marginBottom: 0}}>
                                            <LabelForm text={t('content.offers.form.age')} />
                                            <InputForm 
                                                id="age"
                                                value={this.state.age}
                                                required={field.required}
                                                disabled={true}
                                                handleChange={this.handleChange}
                                                validate={this.props.validate}
                                            />
                                        </div>
                                    </div> 
                                : null
                            : null
                        : null
                    )}
                </div>
                <div className="col-md-12 no-padding">
                    {this.props.fields.map((field, i)=>
                        field.section_key === 'DONOR' ?
                            field.print ?
                                field.key === 'NAMES' ?
                                    <div className=" col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.names')} />
                                        <InputForm 
                                            id="names"
                                            value={this.state.names}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            maxLength={100}
                                        />
                                    </div>
                                : field.key === 'LASTNAME1' ?
                                    <div className="col-xs-12 col-sm-2"key={i}>
                                        <LabelForm text={t('content.offers.form.lastname1')} />
                                        <InputForm 
                                            id="lastname1"
                                            value={this.state.lastname1}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            maxLength={50}
                                        />
                                    </div>
                                : field.key === 'LASTNAME2' ?
                                    <div className="col-xs-12 col-sm-2" key={i}>
                                        <LabelForm text={t('content.offers.form.lastname2')} />
                                        <InputForm 
                                            id="lastname2"
                                            value={this.state.lastname2}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            maxLength={50}
                                        />
                                    </div>
                                : field.key === 'EMAIL' ?
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.email')}  />
                                        <LabelForm text={this.state.error_email} styles={{color:'red', marginLeft:8, fontSize:11}} />
                                        <InputForm 
                                            id="email"
                                            value={this.state.email}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                        />
                                    </div>
                                : field.key === 'SCHOLARSHIP' ?
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.scholarship')}  />
                                        <SelectForm 
                                            id="scholarship"
                                            value={this.state.scholarship}
                                            options={this.state.scholarships}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                        />
                                    </div>
                                : field.key === 'JOB_PROFILE' ?
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.job_profile')} />
                                        <AutocompleteForm 
                                            id="job_profile"
                                            validate={this.props.validate}
                                            options={this.state.jobProfiles}
                                            disabled={this.props.blockFields}
                                            selected={this.state.index_job !== -1 ? [this.state.jobProfiles[this.state.index_job]] : []}
                                            handleChange={this.onAutocompleteChange}
                                            inputProps={{
                                                required:field.required,
                                                id:"job_profile"
                                            }}
                                            reference="_handleSeachJob"
                                            loading={this.state.load_job}
                                            onRef={ref => this.autocomplete_job = ref} 
                                        />
                                        
                                    </div>
                                : field.key === 'IDEE' ?
                                    <div className='col-xs-12 col-sm-4' key={i}>
                                        <LabelForm text="IDEE" />
                                        <InputForm 
                                            id="idee"
                                            value={this.state.idee}
                                            disabled={true}
                                            handleChange={this.handleChange}
                                        />
                                    </div>
                                : null
                            : null
                        : null
                    )}
                </div>
                
            </fieldset>
        )
    }
}

export default translate('translations') (DonorData);